import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { Subscriber } from 'rxjs';
import { Observable, of } from 'rxjs';

@Pipe({
    name: 'appImageFilePreview',
    pure: true
})
export class AppImageFilePreviewPipe implements PipeTransform {

    transform(value: File, ...args: any[]): Observable<string> {
        if (!(value instanceof File)) {
            return of(null);
        }

        // Check the file is an image
        if (value.type.indexOf('image/') !== 0) {
            return of(null);
        }

        return new Observable<string>((observer: Subscriber<string>) => {
            const reader = new FileReader();

            reader.onloadend = (event: ProgressEvent<FileReader>) => {
                const result = event.target.result as string;

                observer.next(result);
                observer.complete();
            };

            reader.onerror = (error: ProgressEvent<FileReader>) => {
                observer.error(error.target.error);
                observer.complete();
            };

            reader.readAsDataURL(value);
        });
    }

}
